import './App.css';
// import ReactGA from 'react-ga';
import Footer from './components/footer.js'
import Home from './components/home';
import Gallery from './components/gallery';
import Testimonials from './components/testimonials';
import Team from './components/team';
import PrivacyPolicy from './components/privacyPolicy';
import TermsAndConditions from './components/termsAndConditions';
import Navbar from './components/navbar';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Scroll to top on route change
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top when pathname changes, not on hash changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {

  // const setGA = () => {
  //   ReactGA.initialize('UA-xxxxxxx-xx');
  //   ReactGA.pageview("Init page view");
  // };

  // useEffect(() => {
  //   setGA();
  // },[]);

    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
          window.pageYOffset > 400 ? setShowButton(true) : setShowButton(false);
        };
        window.addEventListener('scroll', handleScroll);
    }, []);
    
    // Disable right-click on entire website
    useEffect(() => {
        const handleContextMenu = (e) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', handleContextMenu);
        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);
    const handleScroll = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    };
  

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {showButton && 
          <div id='backToTop' onClick={handleScroll}>
            <FontAwesomeIcon icon={faArrowUp} />
          </div>
        }
        <a 
          href="https://wa.me/917001385764" 
          target="_blank" 
          rel="noopener noreferrer" 
          id='whatsappFloat'
          aria-label="Contact us on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <Navbar />
        <main className="site-main">
          <Routes>
            <Route path="/" exact element={<Home/>} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/team" element={<Team />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router> 
  );
}

export default App;